export default "__VITE_ASSET__BzEdzabd__"